import { APP_CONFIG } from '../constants/APP_CONFIG';
import { createHttpClient } from './utils/createHttpClient';

/**
 * Makes requests DIRECTLY to the Legacy Rails SD Backend FROM THE BROWSER
 *
 * NOTE: This is private, the only reason we make direct calls is to manipulate the
 * Rails session and those calls MUST come directly from the browser due to the nature
 * of sessions being tied to browser cookies
 */
export const sdLegacyBrowserClient = createHttpClient({
  config: {
    baseURL: APP_CONFIG.services.sellerDashboardLegacy.baseUrl,
    withCredentials: true
  }
});
